import { jsx as _jsx } from "react/jsx-runtime";
import { MessageSquareText } from 'lucide-react';
import { createModulePerms } from '@wit-support/ui-domain';
import { CommentsPage } from './routes/comments-page.js';
import { TagsPage } from './routes/tags-page.js';
const { Provider: AnnotationsModulePermsProvider, usePerms: useAnnotationsPerms } = createModulePerms({
    canManageTags: false,
    canListAdmins: false,
    canManageComments: false,
    currentAdminId: null,
});
export { AnnotationsModulePermsProvider, useAnnotationsPerms };
function CommentsRoute() {
    const { canListAdmins, canManageComments, currentAdminId } = useAnnotationsPerms();
    return (_jsx(CommentsPage, { canListAuthors: canListAdmins, canManageComments: canManageComments, currentAdminId: currentAdminId }));
}
function TagsRoute() {
    const { canManageTags } = useAnnotationsPerms();
    return _jsx(TagsPage, { canManage: canManageTags });
}
export const annotationsModule = {
    id: 'annotations',
    label: 'Комментарии',
    icon: MessageSquareText,
    // Право ЧТЕНИЯ диалогов — то же, что гейтит `GET /api/conversations/:id`.
    // Комментарий без своего диалога бессмыслен, поэтому отдельного права на
    // ленту нет: кто видит диалоги, тот видит и заметки по ним.
    permission: 'conversation.read',
    workspace: 'support',
    // Сразу за «Диалогами» (order 10) и перед «Администраторами» (20): лента —
    // второй взгляд на тот же материал, а не служебный раздел.
    order: 15,
    description: 'Внутренние заметки операторов по всем диалогам и общий словарь тегов.',
    showInNav: true,
    /*
      Корневой экран модуля — ЛЕНТА, а не отдельный адрес `/comments`.
  
      Пункт сайдбара ведёт на базу модуля (`/annotations`) — это `NavList` в
      шелле, а не выбор раздела. Модуль без маршрута '/' дал бы пункт меню,
      который открывает 404, и поймать это можно было бы только кликом.
    */
    sections: [
        { path: '/', label: 'Комментарии' },
        { path: '/tags', label: 'Теги' },
    ],
    routes: [
        { path: '/', component: CommentsRoute },
        { path: '/tags', component: TagsRoute, label: 'Теги' },
    ],
};
export { CommentsPage, conversationLinkLabel, canEditComment } from './routes/comments-page.js';
export { TagsPage, deleteTagConfirmText } from './routes/tags-page.js';
export { RenameTagDialog } from './forms/rename-tag-dialog.js';
export { setAnnotationsApiBaseUrl, listComments, listCommentAuthors, listTags, renameTag, deleteTag, commentFeedQueryString, tagListQueryString, COMMENTS_PAGE_SIZE, TAGS_PAGE_LIMIT, } from './api.js';
//# sourceMappingURL=index.js.map